import React, { useEffect, useState } from "react";
import { Card } from "../../components/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../../components/ui/dialog";
import { FiEdit } from "react-icons/fi";

import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../../components/ui/select";

import maplimitService from "../../service/maplimit.service";

const MapLimit = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Edit Modal States
  const [open, setOpen] = useState(false);
  const [editForm, setEditForm] = useState({
    limit: "",
    frequency: "",
  });
  const [saving, setSaving] = useState(false);

  // Fetch Data --------------------------------------------------
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await maplimitService.getMapLimitConfig();

      const item =
        response?.data?.data || // axios → response.data.data
        response?.data ||
        null;

      setData(item ? [item] : []);
    } catch (error) {
      console.error("Error fetching:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Open Edit Modal ---------------------------------------------
  const handleEdit = (item) => {
    setEditForm({
      limit: item.limit,
      frequency: item.frequency,
    });
    setOpen(true);
  };

  // Update Data --------------------------------------------------
  const handleUpdate = async () => {
    try {
      setSaving(true);

      const body = {
        limit: Number(editForm.limit),
        frequency: editForm.frequency,
      };

      await maplimitService.updateMapLimitConfig(body);

      setOpen(false);
      await fetchData(); // refresh table
    } catch (error) {
      console.error("Update failed:", error);
      alert("Error updating configuration");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-4">
      <Card className="p-10 grid gap-6">
        <div className="flex items-center justify-between">
          <h3 className="text-xl tab:text-2xl font-bold">Map Limit</h3>
        </div>

        <div className="overflow-y-auto">
          <Table className="whitespace-nowrap">
            <TableHeader>
              <TableRow>
                <TableHead className="w-20">No</TableHead>
                <TableHead className="w-32">Limit</TableHead>
                <TableHead className="w-40">Frequency</TableHead>
                <TableHead className="w-32">Action</TableHead>
              </TableRow>
            </TableHeader>

            <TableBody>
              {loading ? (
                <TableRow className="h-40">
                  <TableCell
                    colSpan={4}
                    className="text-center text-black/50 font-medium text-xl"
                  >
                    Loading...
                  </TableCell>
                </TableRow>
              ) : data.length > 0 ? (
                data.map((item, index) => (
                  <TableRow key={item._id || index}>
                    <TableCell className="w-20">{index + 1}</TableCell>
                    <TableCell className="w-32">{item.limit}</TableCell>
                    <TableCell className="w-40">{item.frequency}</TableCell>
                    <TableCell className="w-30">
                      <FiEdit
                        onClick={() => handleEdit(item)}
                        className="cursor-pointer text-blue-600 hover:text-blue-800"
                        size={20}
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow className="h-40">
                  <TableCell
                    colSpan={4}
                    className="text-center text-black/50 font-medium text-xl"
                  >
                    No data found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </Card>

      {/* Edit Dialog */}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Edit Map Limit</DialogTitle>
          </DialogHeader>

          <div className="grid gap-4">
            {/* Limit Input */}
            <div>
              <label className="text-sm font-medium">Limit</label>
              <Input
                type="number"
                value={editForm.limit}
                onChange={(e) =>
                  setEditForm({ ...editForm, limit: e.target.value })
                }
              />
            </div>

            {/* Frequency Select */}
            <div>
              <label className="text-sm font-medium">Frequency</label>
              <Select
                value={editForm.frequency}
                onValueChange={(value) =>
                  setEditForm({ ...editForm, frequency: value })
                }
              >
                <SelectTrigger>
                  <SelectValue placeholder="Select Frequency" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="daily">Daily</SelectItem>
                  <SelectItem value="weekly">Weekly</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>

          <DialogFooter>
            <Button variant="secondary" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button onClick={handleUpdate} disabled={saving}>
              {saving ? "Saving..." : "Save"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default MapLimit;
